import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

interface Props {
  top?: any;
}

const CustomConnector = styled(StepConnector)(({ theme }) =>(props: Props) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top:  parseInt(props.top || 10),
    left: "calc(-50% + 12px)",
    right: "calc(50% + 12px)",
  },

  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#E9E9F0",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#02B271",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 4,
    borderRadius: 1,
  },
}));

export default CustomConnector;
